/**
 * Created by piotr.pozniak@thebeaverhead.com on 29/10/2018.
 */

import React, { useCallback, useEffect, useMemo, useState } from "react";

import { SketchPicker } from "react-color";
import classNames from "classnames";
import { func } from "prop-types";

/**
 *
 * @param {string} id
 * @param {boolean} disabled
 * @param {function} onColorChagnge
 * @param {string} color
 * @returns {React.JSX.Element}
 * @constructor
 */
const ColorSelector = ({
  id,
  disabled,
  onColorChagnge,
  color,
  onPickerOpen,
}) => {
  const domId = "color-picker-" + id;

  const [state, setState] = useState({
    showColorPicker: false,
  });

  useEffect(() => {
    /**
     *
     * @param event
     */
    const handleClickOutsidePicker = (event) => {
      const pickerContainer = document.querySelector("#" + domId);

      if (!pickerContainer.contains(event.target) && state.showColorPicker) {
        setState({ showColorPicker: false });
      }
    };

    document.addEventListener("click", handleClickOutsidePicker);

    return () => {
      document.removeEventListener("click", handleClickOutsidePicker);
    };
  });

  /**
   *
   */
  const onShowPicker = useCallback(() => {
    setState({ showColorPicker: true });
    if (typeof onPickerOpen === "function") {
      onPickerOpen();
    }
  }, [onPickerOpen, setState]);

  const colorPicker = state.showColorPicker ? (
    <SketchPicker onChange={onColorChagnge} color={color} enableAlpha={true} />
  ) : null;

  const inlineStyle = useMemo(() => ({ background: color }), [color]);

  return (
    <div className="color-picker-container" id={domId}>
      <div
        className={classNames("color-picker-preview", {
          disabled,
        })}
        onClick={onShowPicker}
      >
        <div className="color-picker-preview-color" style={inlineStyle} />
      </div>

      <div className="color-picker-popover">{colorPicker}</div>
    </div>
  );
};

export default ColorSelector;
